"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _BaseComponents = require("../StyledComponents/BaseComponents");
var _CustomIconOrImage = _interopRequireDefault(require("../shared/CustomIconOrImage"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const StyledGrid = (0, _BaseComponents.GrayBackground)(_r10SourceLibrary.Grid);
const QuestionWithStopMessage = _ref => {
  let {
    question
  } = _ref;
  const {
    actionBtnText,
    actionBtn,
    actionBtnNavigationURL,
    messageText
  } = question;
  return /*#__PURE__*/_react.default.createElement(StyledGrid, {
    className: "error-page"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      paddingTop: '10px',
      paddingBottom: '35px'
    },
    "data-test-id": "stop-message"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
    name: "info-circle",
    group: "midLight",
    size: 5
  })), messageText && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, messageText), actionBtn && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: '20px'
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    justify: "center",
    layout: {
      sm: [12],
      md: [6]
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    dataAttributes: {
      'data-test-id': 'action-button'
    },
    width: "full",
    text: actionBtnText,
    onClick: () => {
      window.open(`${actionBtnNavigationURL}?icmp=guiding-selling-solutions-tool`, '_self');
    }
  })))));
};
var _default = QuestionWithStopMessage;
exports.default = _default;